export const Bio = {
  name: "Samridhi Duggal",
  roles: [
    "An Engineer",
    "Web Developer",
    "A Published Author",
    "A Programmer",
  ],
  description:
    "Hello, I am Samridhi Duggal, an Engineer. I was born in Dehradun and currently doing my undergraduation from Graphic Era Deemed to be University, Dehradun, Uttarakhand. I am a Final Year student pursuing Bachelor's of Technology in Computer Science Engineering. I have gained experience in the field of web development through my projects. I try to grab any opportunity that can help me brush up my skills. I am versatile and have good leadership skills. Hope you would like to connect with me.",
  github: "https://github.com/samridhiduggal",
  resume:
    "https://drive.google.com/file/d/1W9iQYHweCxs9XsLe9we5TM6kPvgvbTRW/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/samridhi-duggal-234a84214/",
  twitter: "https://twitter.com/samridhiduggal7",
  insta: "https://www.instagram.com/samridhi_duggal/",
  email: "https://mail.google.com/mail/u/0/",
  linktree: "https://linktr.ee/samridhiduggal",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "MERN Stack",
        image:"https://imgs.search.brave.com/tOFp_XbGp9fcB4om8wqH0ET9hIO0UaNq7TYnl-4sRuQ/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9ibG9n/Lm5leHRpZGVhdGVj/aC5jb20vd3AtY29u/dGVudC91cGxvYWRz/LzIwMjIvMTIvMV9G/VnRDeVJkSjZLT3I0/WXN3VHR3TWVBLmpw/ZWc"
      },
      {
        name: "MySQL",
        image:
          "https://imgs.search.brave.com/8yN8cXptZMszsX2gfPlDvsg0TzVwshSntURY8oFd7RQ/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9wbmdp/bWcuY29tL3VwbG9h/ZHMvbXlzcWwvbXlz/cWxfUE5HMjIucG5n",
      },
      {
        name: "PHP",
        image:
          "https://imgs.search.brave.com/Z2xHJx3a2MDk23NEmKRjs-W_nGwb3zKLM6QLFeQ7iQg/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9wbmdp/bWcuY29tL3VwbG9h/ZHMvcGhwL3NtYWxs/L3BocF9QTkc1MC5w/bmc",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Vercel",
        image:
        "https://imgs.search.brave.com/26RYV7rt9f6Skz8VBAmxf0vmw5BlKn6GhSvFLUg9UjU/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9jbXMu/aW50dWppLmNvbS93/cC1jb250ZW50L3Vw/bG9hZHMvMjAyMi8w/Ni9Mb2dvX1ZlcmNl/bC0xLmpwZw"
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://imgs.search.brave.com/KKJIrQ-245Cr19aRHRI-va8SlKimZ9XhqL7EN3j2Ix4/rs:fit:500:0:0/g:ce/aHR0cHM6Ly91bml2/ZXJzaXR5a2FydC5i/LWNkbi5uZXQvL0Nv/bnRlbnQvdXBsb2Fk/L2FkbWluLzMyMjB1/MGZ3LmhpMC5qcGc",
    role: "Front End Developer",
    company: "Graphic Era Deemed to be University",
    date: "July'23-August'23(For 6 weeks)",
    desc: "A real world project named 'VEGEASE' which is made using Web Development technologies.  The customer can enroll on the website, easy delivery and order placing is easily possible. I made the project under the mentorship of my professor where I developed the front end of the website (I worked in a team of 5 members in this project.) Also, I led the team as a Leader.",
    skills: [
      "Leadership",
      "Web Development",
      "HTML",
      "CSS",
      "JS",
      "BootStrap",
      "React",
      "Netlify",
    ],
  },
  {
    id: 1,
    img: "https://www.appleacademicpress.com/images/logo.png",
    role: "Research",
    company: "Apple Academic Press",
    date: "December'21 - March'22",
    desc: "A survey on attack and defence mechanism in V2X technology which is ready to be published as a book chapter where I worked in a team under the guidance of my professor.  I wrote the sections such as background of V2X technology, attack mechanism and defence mechanisms on V2X. Through this, I got to learn about one of the latest technologies that are available around the world.",
    skills: [
      "Research",
      "V2X",
      "IOT",
    ],
    doc: "https://www.appleacademicpress.com/hybrid-optical-wireless-networks-and-sensor-technologies-/9781774917442",
  },
];

export const education = [
  {
    id: 0,
    img: "https://imgs.search.brave.com/KKJIrQ-245Cr19aRHRI-va8SlKimZ9XhqL7EN3j2Ix4/rs:fit:500:0:0/g:ce/aHR0cHM6Ly91bml2/ZXJzaXR5a2FydC5i/LWNkbi5uZXQvL0Nv/bnRlbnQvdXBsb2Fk/L2FkbWluLzMyMjB1/MGZ3LmhpMC5qcGc",
    school: "Graphic Era Deemed to be University, Dehradun, Uttarakhand.",
    date: "2020-2024",
    grade: "8.36 CGPA",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://universalbooksellers.com/wp-content/uploads/2021/03/cms.png",
    school: "City Montessori School, Lucknow, Uttar Pradesh.",
    date: "2019-2020",
    grade: "80.33%",
    degree: "ISC(XII), PCM + Computer",
  },
  {
    id: 2,
    img: "https://universalbooksellers.com/wp-content/uploads/2021/03/cms.png",
    school: "City Montessori School, Lucknow, Uttar Pradesh.",
    date: "2017-2018",
    grade: "87.16%",
    degree: "ICSE(X), Science + Computer",
  },
];

export const projects = [
  {
    id: 0,
    title: "Echoes Of Life",
    date: "Jan'24",
    description:
      "A website where people can visit and share their memories. This website is built for those people who like to share their experiences with others or like to write blogs, and also for those who can't share their feelings in person with others, so they can come and visit repository of their choice and write the post. Future work: to do the backend.",
    tags: ["HTML", "CSS", "JAVASCRIPT", "REACTJS", "BOOTSTRAP"],
    category: "Web Application",
    github: "https://github.com/samridhiduggal/echoesoflife_frontend",
  },
  {
    id: 0,
    title: "Youtube Clone",
    date: "Jan'24",
    description:
      "Led  the  development  of  a  YouTube  clone  from  scratch,  showcasing  expertise  in  both  front-end  and  back-end  technologies. Utilized  Reactjs,  Redux,  MUI  Materials  and  API’s  to  create  a  fully  functional  video-sharing  platform. Ensured  a  seamless  and  inclusive  user  experience  by  implementing  a  responsive  design  that  dynamically  adapts  to  various screen  sizes  and  resolutions.   Also,  developed  sophisticated  search  functionality.",
    tags: ["HTML", "CSS", "JAVASCRIPT", "REACTJS", "BOOTSTRAP", "Material MUI", "API"],
    category: "Web Application",
    github: "https://github.com/samridhiduggal",
  },
  {
    id: 0,
    title: "VegEase",
    date: "July'23-August'23",
    description:
      "A real world project named 'VEGEASE' which is made using Web Development technologies.  The customer can enroll on the website, easy delivery and order placing is easily possible.",
    tags: ["HTML", "CSS", "JAVASCRIPT", "REACTJS", "BOOTSTRAP"],
    category: "Web Application",
    github: "https://github.com/samridhiduggal",
    webapp: "https://vegetable-fruit.netlify.app/",
  },
  {
    id: 1,
    title: "GrooveBot",
    date: "May'23",
    description:
      "A Chatbot Song Recommendation System. A website where a user can be recommended songs based on their mood.  The chatbot named ”GrooveBot” communicates with the user to know about their mood and it provides with a playlist and the artist which can help them cheer up thier mood. An user logins into the site where the chatbot is ready to communicate.  Upon communicating, chatbot suggests songs to user.",
    tags: ["HTML", "CSS", "JAVASCRIPT", "PHP", "DATABASE"],
    category: "Chatbot",
    github: "https://github.com/samridhiduggal",
    webapp: "https://chatbot-amber-nu-58.vercel.app/",
    },
];
